import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Type } from '@nerdwallet/currency';

import CompanyHeader from './company-header/company-header';
import CompanyStroke from '../company-stroke/company-stroke';
import MeetNerds from './company-meet-nerds/company-meet-nerds';

import MeetNerdsData from '../../lib/company-content-src/company-meet-nerds-content';
import MeetNerdsDataDesktop from '../../lib/company-content-src/company-meet-nerds-content-desktop';

const NotFound = ({ errorType }) => {
  const errorButtonCopy =
    errorType === 'department'
      ? 'See current departments'
      : 'See current open positions';
  const careersPath = '/careers';

  return (
    <Fragment>
      <div
        className={classNames([
          classes('width-auto'),
          classes('text-align-center'),
          classes('margin-vertical-5'),
          classes('margin-horizontal-3'),
        ])}
      >
        <Type
          gotham
          size="3"
          className={classNames([
            classes('display-block'),
            classes('max-width-prose-wide'),
            classes('margin-horizontal-auto'),
            classes('margin-bottom-4'),
          ])}
        >
          That {errorType} was not found
        </Type>
        <Button primary href={careersPath}>
          {errorButtonCopy}
        </Button>
      </div>
      <CompanyStroke />
      <div
        className={classNames([
          classes('width-auto'),
          classes('text-align-center'),
          classes('margin-vertical-5'),
          classes('margin-horizontal-3'),
        ])}
      >
        <CompanyHeader headerText="Meet Our Nerds" />
        <div>
          <div
            className={classNames([
              classes('display-block'),
              classes('display-none--wide'),
            ])}
          >
            <MeetNerds {...MeetNerdsData} />
          </div>
          <div
            className={classNames([
              classes('display-none'),
              classes('display-block--wide'),
            ])}
          >
            <MeetNerds {...MeetNerdsDataDesktop} />
          </div>
        </div>
      </div>
      <CompanyStroke />
      <div
        className={classNames([
          classes('width-auto'),
          classes('text-align-center'),
          classes('margin-vertical-5'),
          classes('margin-horizontal-3'),
        ])}
      >
        <Type
          gotham
          size="3"
          className={classNames([
            classes('display-none--wide'),
            classes('max-width-prose'),
            classes('margin-horizontal-auto'),
            classes('margin-bottom-4'),
          ])}
        >
          Be a part of life at NerdWallet.
          <br />
          Join our team.
        </Type>
        <Type
          gotham
          size="3"
          className={classNames([
            classes('display-none'),
            classes('display-block--wide'),
            classes('max-width-prose-wide'),
            classes('margin-horizontal-auto'),
            classes('margin-bottom-4'),
          ])}
        >
          Follow us on LinkedIn for more info about life at NerdWallet
        </Type>
        <Button primary href="https://www.linkedin.com/company/nerdwallet">
          Click here
        </Button>
      </div>
    </Fragment>
  );
};

NotFound.displayName = 'Not Found';

NotFound.propTypes = {
  errorType: PropTypes.string,
  location: PropTypes.object,
};

export default NotFound;
